import { render, staticRenderFns } from "./orderdetails.vue?vue&type=template&id=1b2677ae&scoped=true"
import script from "./orderdetails.vue?vue&type=script&lang=ts"
export * from "./orderdetails.vue?vue&type=script&lang=ts"
import style0 from "./orderdetails.vue?vue&type=style&index=0&id=1b2677ae&prod&lang=scss&scoped=true"
import style1 from "./orderdetails.vue?vue&type=style&index=1&id=1b2677ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2677ae",
  null
  
)

export default component.exports